export const expenses = {
    "name_of_supplier": "Nombre del proveedor ",
    "payment_frequency": "Frecuencia de pago ",
    "expense_record_table_title": "Registrar el pago",
    "expense_record_table_type": "Tipo de gasto",
    "expense_record_table_index": "#",
    "expense_record_table_invoice": "Numero de factura",
    "expense_record_table_upload": "Upload invoice",
    "expense_record_table_period": "Periodo de gastos",
    "expense_record_table_to": "Para",
    "expense_record_table_from": "De",
    "expense_record_table_description": "Descripción de los gastos",
    "description_placeholder": "Ingresa la descripción del artículo",
    "expense_record_table_amount": "Monto",
    "expense_record_table_actions": "",
    "record_expense": "Registrar gastos",
    "add_line": "Añadir línea",
    "email": "Correo electrónico",
    "comment": "Comentario",
    "total_amount": "Monto mensual total",
    "added_successfully": "Los gastos se añadieron con éxito",
    "new_supplier": "Añadir nuevo proveedor",
    "phone_number": "Número de teléfono",
    "paymentDetails": "Detalles del pago - cantidad total de {{total}}ILS",
    "name": "Nombre",
    "vat_number": "Identificación fiscal del proveedor",
    "vat_number_link_text": "Puedes buscar aquí",
    "add_vendor": "Añadir nuevo proveedor",
    "expense_monthly_report": "Gastos mensuales",
    "one_time": "Una vez",
    "oneTime": "Una vez",
    "recurring": "Pago recurrente",
    "expense_type": "Tipo de gasto",
    "expense_status": "Estado de gastos",
    "show_reconsiled": "Mostrar solo conciliados",
    "income_type": "Income type",
    "total_needed": "Total necesario",
    "total_balance": "Total",
    "count_balance": "Importe inicial + Ingresos totales - Gastos totales",
    "expenseTypes": {
        "oneTime": "Una-vez",
        "ongoing": "Mensual de {{year}}",
        "pastYearDebts": "Deuda del año pasado",
        "gardening": "Jardinería",
        "plumbing": "Plomería",
        "electricity": "Electricidad",
        "elevators": "Ascensores",
        "lighting": "Iluminación",
        "managementCompany": "Empresa de administración",
        "intercom": "Intercomunicador",
        "electricalGate": "Portal electrico",
        "parkingLot": "Aparcamiento",
        "depretiation": "Depreciación",
        "fireSystem": "Sistema contra incendios",
        "garbage": "Basura ",
        "other": "Otros",
        "airCondition": "Aire acondicionado",
        "cleaning": "Limpieza",
        "pestControl": "Control de plagas",
        "insurance": "Seguro",
        "waterReserve": "Reserva de agua",
        "internet": "Internet",
        "generatorMaintenance": "Generador",
        "creditCommissions": "Comisión de crédito",
        "bankCommissions": "Comisión bancaria",
        "parkingElectricity": "Electricidad del parking",
        "publicElectricity": "Electricidad de las zonas comunes",
        "agudaFee": "Asociación para la Cultura de la Vivienda",
        "dailerFire": "Marcador automático para detector de incendios",
        "buildingSavings": "Construyendo ahorros",
        "solarSystems": "Sistemas solares",
        "doorsMaintenance": "Mantenimiento de Puertas",
        "electricityMaintenance": "Mantenimiento de electricidad",
        "lobbyMaintenance": "Mantenimiento del vestíbulo",
    },
    "vendor_name_is_required": "Se requiere el nombre del proveedor",
    "approve": "Aprobar",
    "continue_and_approve": "Continuar para su aprobación",
    "date": "Fecha de acción",
    "actual_date": "Fecha de acción real",
    "select_payment_type": "Selecciona el tipo de pago",
    "income_modal_title": "Confirmo que el registro de Bllink coincide con el del banco",
    "deposit_date": "Fecha de depósito",
    "actual_deposit_date": "Fecha de depósito real",
    "bank": "Banco",
    "branch": "Sucursal",
    "account": "Número de cuenta",
    "cheque_num": "Número de cheque",
    "wire": "Transferencia",
    "cheque": "Cheque",
    "cash": "Depósito en ventanilla",
    "type": "Tipo",
    "description": "Descripción",
    "approved": "Aprobado",
    "pending": "Pendiente",
    "all": "Todo",
    "bank_adjustments_title": "Validación de los ingresos y gastos del informe bancario",
    "expense": "Gastos",
    "income": "Ingreso",
    "expenses": "Expenses",
    "approveSuccess": "La transacción se aprobó con éxito",
    "upload_doc": "Cargar archivo",
    "upload_success": "Se cargó el recibo",
    "file_size_error": "El tamaño del archivo es superior a 2 MB",
    "disabled_pending": "Esta transacción se aprobará automáticamente",
    "expense_future_monthly_report": "Informe mensual de gastos futuros: detalles de los gastos que se realizarán en {{monthName}} {{year}} - Total {{amount}} {{currency}}",
    "vendor_created": "Se ha creado correctamente un nuevo proveedor",
    "choose_vendor": "Seleccionar proveedor",
    "expense_record_tooltip": "Haga clic aquí para documentar los gastos del proveedor",
    "bank_adjustments_tooltip": "Haga clic aquí para ajustes bancarios",
    "no_vendor_has_been_selected": "No es posible documentar un gasto sin elegir un proveedor. Seleccione un proveedor",
    "payment_method": "Método de pago",
    "bank_comission": "Hay un costo de instalación de 15 NIS para el banco",
    "bank_adjustments": {
        "title": "Ajustes bancarios",
        "file": "Archivo",
        "to": "Para",
        "from": "De",
        "apt_num": "Apt {{apt}}",
        "cheque_number": "Número del cheque",
        "wire_number": "Número de la transferenciar",
        "bank_number": "Clave bancaria",
        "cash_number": "Deposit confiramtion",
        "document_number": "Número del documento",
        "bllink_records": "Registros de Bllink",
        "bank_records": "Registros bancarios",
        "drag_and_drop": "Arrastrar & soltar archivo desde el banco",
        "no_files": "No hay archivos cargados anteriormente",
        "reconciliation_header": "Seleccione la transacción que desee conciliar",
        "start_auto_reconciliation": "Iniciar conciliación automática",
        "manual_reconciliation": "Conciliación manual",
        "auto_match_title": "Ajuste automático - examen de resultados",
        "choose_pairs": "Elegir las parejas adecuadas",
        "approve_all": "Aprobar todos los elementos marcados",
        "items_have_same_amount": "Los elementos seleccionados contienen la misma cantidad",
        "press_approve": "Haga clic en Aceptar para hacer un ajuste",
        "upload_failure": "El archivo no se puede subir",
        "load_failure": "El archivo no se puede cargar",
        "bytes": "bytes",
        "balance": "Balance",
        "description": "Descripción",
        "credit": "Crédito",
        "debit": "Débito",
        "bllink_tooltip": "Aquí están sus transacciones con Bllink.",
        "bank_tooltip": "Aquí están sus transacciones bancarias.",
        "no_receipt": "Todavía no se ha subido ningún recibo",
        "no_matches": "No se han encontrado coincidencias",
        "no_records": "Archivo no encontrado",
        "manual_error": "Elija transacciones con la misma cantidad",
        "approved_transaction": "La transacción con Bllink {{id}} ha sido aprobada con éxito",
        "not_approved_transaction": "La transacción con Bllink {{id}} no ha sido aprobada",
        "clear_records": "Borrar registros bancarios",
        "expenses_type": "Tipo de gastos",
        "total_paid": "Total pagado",
        "offline_only": "Solo pagos fuera de línea",
    },
    "set_expenses": {
        "confirmation_title": "Confirmación de gastos",
        "title_add_expense": "Agregar gasto a",
        "manage_expenses": "Gestión de gastos de construcción",
        "connect_bank_account": "Conectar la cuenta bancaria del edificio para pago a proveedores. Luego se elige Bllink como medio de pago y el dinero se transfiere directamente a la cuenta bancaria del proveedor. Sin esfuerzo.",
        "add_expense": "Agregar gasto",
        "online_interface": "Administre todos los gastos del edificio en la interfaz en línea",
        "use_bllink_digital_payments": "Utilice el pago digital de Blink para transferir fondos a los proveedores del edificio. O documente los pagos realizados con cheque, transferencia bancaria, efectivo.",
        "establish_expense": "Establecer un nuevo gasto para el edificio.",
        "for_payments": "Para el pago que hay que hacer al proveedor (compañía eléctrica, jardinería, ascensores...)",
        "add_means_of_payment": "Continuar agregando medios de pago",
        "skip_saving": "O omita guardar en el informe de gastos e ingrese un medio de pago más tarde",
        "payment_is_recorded": "El pago se registra en el informe de gastos del edificio.",
        "enters_icome_balance": "Y entra en el saldo de ingresos de los gastos",
        "add_expense_for": "Agregar gasto para",
        "search_vendor": "Buscar o agregar proveedor",
        "choose_type": "Elija el tipo de gasto",
        "save_and_add_method": "Guardar y agregar método de pago",
        "num_of_months": "Número de meses",
        "upload_invoice_file": "Subir factura/archivo",
        "select_date": "Seleccione fecha",
        "save_and_close": "Guardar y cerrar",
        "set_reccurent_payment": "Está configurando un pago recurrente de <monthsNum> de <amount> a <vendorName>",
        "continue": "Continuar",
        "pay_with_bllink": "Paga con Bllink",
        "easy_payment": "Pago fácil",
        "first_step": "Paso 1",
        "second_step": "Paso 2",
        "third_step": "Paso 3",
        "add_payment_method": "Añadir método de pago",
        "free": "Libre",
        "set_one_time_payment": "Estás pagando <currency><amount> a <vendorName>",
        "pay_with_bllink_or_record_offline": "¿Quieres Pagar con Bllink o grabar el pago?",
        "record_wire_payment": "Registro de pago por transferencia bancaria",
        "record_cheque_payment": "Registro de pago de cheques",
        "record_cash_payment": "Registrar pago en efectivo",
        "cheque_payment": "Cheque de pago",
        "cash_payment": "Pago en efectivo",
        "wire_payment": "Pago por transferencia",
        "wire_confirmation_num": "Número de confirmación de transferencia",
        "amount_out_of_range": "Tenga en cuenta que el monto de pago de bit está entre <min>₪ a <max>₪. Por favor, elija un método de pago diferente",
        "select_months_placeholder": "Seleccione",
        "setExpenseSuccess": "Éxito en la configuración de gastos",
    },
    "balance_report": {
        "fromDate": "De la fecha",
        "toDate": "A la fecha",
    },
    "from": "De",
    "to": "A",
    "status": "Estado",
    "payment_type": "Tipo de pago",
    "register": {
        "title": "¿Aún no has dado de alta tu edificio a los gastos de obra nueva?",
        "registerHere": "Registrar aquí",
    }
};
